module.exports = "/_next/static/images/search_bg_30-cccad310239dbedbb1cfe236f4283b3e.jpg";